import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign',
  templateUrl: './campaign.component.html',
  styleUrls: ['./campaign.component.css']
})
export class CampaignComponent implements OnInit {

  //function
  scrollFn(anchor: string): void {
    document.getElementById(anchor).scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest"
    });
  }
  constructor() { }

  ngOnInit() {
  }

}
